(ns journal-app-client.modals.id-selection
  (:require [journal-app-client.components.button :as button]
            [journal-app-client.components.input :as input]
            [journal-app-client.utils.formatting :as fmt]
            [journal-app-client.components.tree :as tree]
            [clojure.string :as s]
            [re-frame.core :as rf]
            [journal-app-client.components.modal :as m]
            [journal-app-client.utils.react :refer [use-state]]))

(defn modal-body-list-fn [id props]
  (let [[state set-state] (use-state "")
        select (:select props)
        [selected-id data-id] (:selected select)
        select-data-path (or (:data-path select) [:information :name])
        get-name-fn (or (:get-name-fn select) (fn [data] (get-in (second data) select-data-path "Unnamed")))
        sorted-data (sort-by get-name-fn
                             (if data-id
                               (filter #(and (not (= data-id (:parent-id (second %))))
                                             (not (= data-id (first %))))
                                       (:data props))
                               (:data props)))]
    [m/body
     [:div.box
      {:style {:position "sticky"
               :top      "0"
               :z-index  "2"}}
      [input/input
       {:placeholder (:text select)
        :auto-focus  true
        :value       state
        :on-change   #(set-state (-> % .-target .-value))}]]
     (into
       [:div.box
        (when (empty? sorted-data)
          [:p.subtitle
           {:style {:color "var(--warning)"}}
           "No data. Please create more to be able to set a parent."])]
       (map-indexed
         (fn [index data]
           (let [data-id (first data)
                 name (get-name-fn data)]
             [button/button
              {:key      (str data-id)
               :class    (str (if (= selected-id data-id)
                                " is-success "
                                " is-outlined ")
                              " is-fullwidth fade-in ")
               :style    {:display (when-not (s/includes? (fmt/lower-case name) (fmt/lower-case state)) "none")
                          :margin  (when (= index (dec (count sorted-data))) "0")}
               :on-click (fn []
                           (when (fn? (:on-click props))
                             ((:on-click props) (when-not (= selected-id data-id) data-id)))
                           (rf/dispatch [:close-modal id]))}
              name]))
         sorted-data))]))

(defn modal-body-tree-fn [id props]
  (let [[search set-search] (use-state "")
        select (:select props)
        data (:data props)
        tree-data (:tree-data props)
        [selected-id data-id] (:selected select)
        [state set-state] (use-state {:open data
                                      :selected-ids #{selected-id}})]
    [m/body
     {:style {:height "100svh"}}
     [:div.box
      {:style {:position "sticky"
               :top      "0"
               :z-index  "2"}}
      [input/input
       {:placeholder (:text select)
        :auto-focus  true
        :value       search
        :on-change   #(set-search (-> % .-target .-value))}]]
     [:div.box
      (when (empty? data)
        [:p.subtitle
         {:style {:color "var(--warning)"}}
         "No data. Please create more to be able to set a parent."])
      [:f> tree/tree-indented
       (assoc props :search (fmt/lower-case search)
              :type (:type select)
              :children tree-data
              :get-name-fn (:get-name-fn select)
              :use-state [state set-state]
              :disabled (fn [{:keys [parent]}] (or (and selected-id (= selected-id (first parent)))
                                                   (and data-id (= data-id (first parent)))))
              :filter (fn [{:keys [parent]}] (and data-id (= data-id (first parent))))
              :on-click (fn [{:keys [parent]}]
                          (let [data-id (first parent)]
                            (when (fn? (:on-click props))
                              ((:on-click props) (when-not (= selected-id data-id) data-id))))
                          (rf/dispatch [:close-modal id])))]]]))
(defn main [id props]
  (let [select (:select props)
        data (or (:data select)
                 (when (:subscribe-data-path select) @(rf/subscribe (:subscribe-data-path select))))
        tree-data (or (:tree-data select)
                      (when (:subscribe-tree-data-path select) @(rf/subscribe (:subscribe-tree-data-path select))))]
    [:<>
     [m/header
      [:h1.modal-card-title (:text select)]
      [button/button
       {:aria-label "Close"
        :class      "is-rounded"
        :style      {:background-color "transparent"
                     :padding          "1rem"
                     :border-color     "var(--scheme-main)"}
        :on-click   #(rf/dispatch [:close-modal id])}
       [:span.icon [:i.fas.fa-close]]]]
     (if tree-data
       [:f> modal-body-tree-fn id (assoc props :data data :tree-data tree-data)]
       [:f> modal-body-list-fn id (assoc props :data data)])]))
